<medrecord-ui-field-label *ngIf="label" [text]="label"></medrecord-ui-field-label>
<ejs-datepicker placeholder="DD/MM/YYYY"
                format='dd/MM/yyyy'
                [formControlName]="controlName"
                [min]="minDate">
</ejs-datepicker>
<medrecord-ui-field-error [errors]="controlErrorsList"
                          [errorCode]="errorCode"
                          [externalErrors]="externalErrorsList"></medrecord-ui-field-error>